import { useEffect, useState } from 'react';
import { getAppInstance } from '@/utils/api/app';
import { getSearchParam } from '@/utils/helpers';
import { AxiosResponse, AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { ReferralTypeFragment } from '@/utils/dato/generated';

type Success = {
  referralType: string;
  message: string;
};

export const useReferralType = ({ referrals }: { referrals: ReferralTypeFragment[] }) => {
  const [referCode, setReferCode] = useState<undefined | string | null>(null);

  useEffect(() => {
    const param = getSearchParam('referral_code') ?? getSearchParam('referralCode');
    setReferCode(param ?? undefined);
  }, []);

  const mutation = useMutation<AxiosResponse<Success>, AxiosError<Error>>({
    mutationFn: async () => await getAppInstance().post<Success>('/referral-type', { referCode }),
    mutationKey: ['mobile-refer-service', referCode],
  });

  useEffect(() => {
    if (referCode) {
      mutation.mutate();
    }
  }, [referCode]);

  const referralType = mutation.data?.data?.referralType || 'invalid_code';

  const selected = referrals.find((block) => block.referralId === referralType) || null;

  return {
    isLoading: mutation.isPending,
    referralType,
    referCode,
    selected,
    mutation,
  };
};
